module.exports = __webpack_public_path__ + "static/verein-hero-img-765060f7df3a9edbbcbcd803ae2572c5.png";